// =============================================================
// OOS Rescue — vanilla JS
// 1) Notify-me form (rescue page): Klaviyo Client Back-in-Stock API
// 2) Size pills: capture-phase event delegation
// 3) Lazy-loads "We have these alternatives" recommendations
// 4) Inline variant notify-me modal (capture-phase) — exposes opener
// 5) Intercept clicks on Horizon's variant picker for sold-out sizes
// =============================================================

// --- 1 & 2: Rescue-page notify-me form + size pill delegation ---
(function () {
  function init() {
    document.querySelectorAll('[data-notify-me]').forEach(setupForm);
  }

  function setupForm(root) {
    var form      = root.querySelector('[data-notify-form]');
    var emailEl   = root.querySelector('[data-notify-email]');
    var btn       = root.querySelector('[data-notify-submit]');
    var label     = root.querySelector('[data-notify-label]');
    var errorEl   = root.querySelector('[data-notify-error]');
    var successEl = root.querySelector('[data-notify-success]');
    var sizesWrap = root.querySelector('.notify-me__sizes');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl.value || '').trim();
      if (!email) return;

      btn.disabled = true;
      label.textContent = 'Sending…';
      errorEl.hidden = true;

      var klaviyoId = (root.dataset.klaviyoId || '').trim();
      var variantId = root.dataset.activeVariantId;

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
          encodeURIComponent(klaviyoId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify(payload)
        }
      )
        .then(function (res) {
          if (!res.ok && res.status !== 202) {
            return res.text().then(function (t) {
              throw new Error('Klaviyo HTTP ' + res.status + ': ' + t);
            });
          }
          form.hidden = true;
          if (sizesWrap) sizesWrap.hidden = true;
          successEl.hidden = false;
        })
        .catch(function (err) {
          console.error('Notify-me submit failed', err);
          errorEl.textContent = 'Something went wrong. Try again in a moment.';
          errorEl.hidden = false;
          btn.disabled = false;
          label.textContent = 'Notify me';
        });
    });
  }

  // Pill click delegation — capture phase
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-variant-pill]');
    if (!pill) return;
    var root = pill.closest('[data-notify-me]');
    if (!root) return;

    root.querySelectorAll('[data-variant-pill]').forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-active');
    pill.setAttribute('aria-pressed', 'true');
    root.dataset.activeVariantId = pill.dataset.variantId;
  }, true);

  // Read More smooth-scroll
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-oos-readmore]');
    if (!link) return;
    e.preventDefault();

    var target =
      document.querySelector('product-information') ||
      document.querySelector('[id^="shopify-section"][id*="main"]') ||
      document.querySelector('shopify-section[type="product-information"]');

    if (!target) {
      var rescue = document.querySelector('[data-oos-rescue]');
      if (rescue) {
        var wrapper = rescue.closest('shopify-section, [id^="shopify-section"]') || rescue.parentElement;
        if (wrapper && wrapper.nextElementSibling) target = wrapper.nextElementSibling;
      }
    }

    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, true);

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


// --- 3: Async product-recommendations loader ---
(function () {
  function loadRecs(el) {
    var productId = el.dataset.productId;
    var intent = el.dataset.intent || 'related';
    var limit = el.dataset.limit || 6;
    var url = '/recommendations/products?product_id=' + productId +
              '&limit=' + limit + '&intent=' + intent +
              '&section_id=oos-recommendations';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var localGrid = el.querySelector('[data-grid]');
        if (!localGrid) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.querySelector('[data-grid]');
        if (freshGrid && freshGrid.children.length > 0) {
          localGrid.innerHTML = freshGrid.innerHTML;
        } else {
          el.style.display = 'none';
        }
      })
      .catch(function () { el.style.display = 'none'; });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-oos-recommendations]');
    if (!nodes.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            loadRecs(e.target);
            obs.unobserve(e.target);
          }
        });
      }, { rootMargin: '200px' });
      nodes.forEach(function (n) { io.observe(n); });
    } else {
      nodes.forEach(loadRecs);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


// --- 4: Notify-me modal (exposes window.OOSRescue.openNotifyModal) ---
(function () {
  var config = {};
  try {
    var raw = document.getElementById('oos-rescue-config');
    if (raw) config = JSON.parse(raw.textContent);
  } catch (e) { console.warn('OOS Rescue: bad config', e); }

  var modal = document.getElementById('notify-modal');
  if (!modal) return;

  var variantInput = modal.querySelector('[data-modal-variant-id]');
  var variantLabel = modal.querySelector('[data-modal-variant-label]');
  var emailEl      = modal.querySelector('[data-modal-email]');
  var form         = modal.querySelector('[data-modal-form]');
  var btn          = modal.querySelector('[data-modal-submit]');
  var btnLabel     = modal.querySelector('[data-modal-label]');
  var errorEl      = modal.querySelector('[data-modal-error]');
  var successEl    = modal.querySelector('[data-modal-success]');

  function openNotifyModal(variantId, label) {
    variantInput.value = variantId;
    variantLabel.textContent = label ? (' — ' + label) : '';
    emailEl.value = '';
    errorEl.hidden = true;
    successEl.hidden = true;
    form.hidden = false;
    btn.disabled = false;
    btnLabel.textContent = 'Notify me';

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  // Expose so IIFE #5 (and anything else) can open the modal
  window.OOSRescue = window.OOSRescue || {};
  window.OOSRescue.openNotifyModal = openNotifyModal;

  // [data-notify-trigger] click → open modal
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-notify-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    openNotifyModal(trigger.dataset.variantId, trigger.dataset.variantLabel);
  }, true);

  // Close on backdrop click
  modal.addEventListener('click', function (e) {
    if (e.target === modal) modal.close();
  });

  // Submit
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (emailEl.value || '').trim();
    if (!email) return;

    btn.disabled = true;
    btnLabel.textContent = 'Sending…';
    errorEl.hidden = true;

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantInput.value
            }
          }
        }
      }
    };

    fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
        encodeURIComponent(config.klaviyoId || ''),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(payload)
      }
    )
      .then(function (res) {
        if (!res.ok && res.status !== 202) {
          return res.text().then(function (t) {
            throw new Error('Klaviyo HTTP ' + res.status + ': ' + t);
          });
        }
        form.hidden = true;
        successEl.hidden = false;
      })
      .catch(function (err) {
        console.error('Notify-me submit failed', err);
        errorEl.textContent = 'Something went wrong. Try again in a moment.';
        errorEl.hidden = false;
        btn.disabled = false;
        btnLabel.textContent = 'Notify me';
      });
  });
})();


// --- 5: Intercept clicks on Horizon's variant picker for sold-out sizes ---
(function () {
  var variants = [];
  try {
    var raw = document.getElementById('oos-rescue-variants');
    if (raw) variants = JSON.parse(raw.textContent);
  } catch (e) { return; }
  if (!variants.length) return;
  if (!window.OOSRescue || !window.OOSRescue.openNotifyModal) return;

  function findVariant(needle) {
    if (needle == null) return null;
    var s = String(needle).trim();
    if (!s) return null;
    return variants.find(function (v) {
      return String(v.id) === s ||
             v.option1 === s ||
             v.option2 === s ||
             v.option3 === s ||
             v.title === s;
    });
  }

  document.addEventListener('click', function (e) {
    // Skip if this click is already handled by an explicit notify trigger
    if (e.target.closest('[data-notify-trigger]')) return;

    // Look for elements inside Horizon's variant picker
    var clickable = e.target.closest(
      'variant-picker input, variant-picker label, variant-picker button, ' +
      '[class*="variant-picker"] input, [class*="variant-picker"] label, [class*="variant-picker"] button, ' +
      'fieldset[name*="variant"] input, fieldset[name*="variant"] label'
    );
    if (!clickable) return;

    // Try multiple strategies to match the clicked element to a variant
    var variant =
      findVariant(clickable.value) ||
      findVariant(clickable.dataset && clickable.dataset.variantId) ||
      findVariant(clickable.textContent);

    if (!variant && clickable.tagName === 'LABEL') {
      var forId = clickable.getAttribute('for');
      if (forId) {
        var input = document.getElementById(forId);
        if (input) variant = findVariant(input.value);
      }
    }

    if (!variant || variant.available) return;

    // Sold-out variant clicked — intercept and open the modal
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.OOSRescue.openNotifyModal(variant.id, variant.option1);
  }, true);
})();